import ExternalLinks from "@/models/storePanel/ExternalLinks";

export default {
    namespaced: true,

    state: () => ({
        externalLink: new ExternalLinks(),
        externalLinks: [],
        uploadingImage: null,
    }),

    mutations: {
        setExternalLinks(state, payload) {
            state.externalLinks = payload;
        },

        setExternalLink(state, payload) {
            state.externalLinks = new ExternalLinks(payload);
        },

        setUploadingImage(state, payload) {
            state.uploadingImage = payload;
        },
    },

    actions: {
        async getExternalLinks({ commit }, query) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ExternalLinks.getExternalLinks(query);
                const { store_external_links, pagination } = data.data;
                commit("setExternalLinks", store_external_links);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }
        },

        async addExternalLink({ commit, state, dispatch }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ExternalLinks.addExternalLink(state.externalLink);

                if(state.uploadingImage) {
                    const fd = new FormData();
                    fd.append("image", state.uploadingImage);
                    await ExternalLinks.uploadImage(data.data.store_external_link_id, fd)
                }

                dispatch("getExternalLinks", "?page=1");
                commit("setUploadingImage", null)
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully created External Link!"
                    },
                    { root: true }
                );
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }
        },

        async remove({ commit, dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });

                await ExternalLinks.delete(id);

                dispatch("getExternalLinks", "?page=1");
                commit("setLoading", false, { root: true });
                commit("setDeleteDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully deleted External Link!"
                    },

                    { root: true }
                );
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }
        },
    }
};
